import styled from "styled-components";
import addIcon from "../../../assets/images/icons/plus-transparent.svg";
import breakpoints from "../../../styles/breakpoints";
import { fonts, colors } from "../../../styles/variables";
import ButtonLink from "../../atoms/ButtonLink";

export const BottleInfoTrayCardButton = styled.button`
  width: 100%;
  height: 100px;
  border: 1px solid black;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 20px;
  align-items: center;
  justify-content: flex-start;
  padding: 0px;
`;

export const BottleInfoTrayCardImageHolder = styled.div`
  min-width: 100px;
  max-width: 100px;
  height: 100%;
  display: flex;
  border: 0px solid black;
  border-right-width: 1px;
  background: url("${addIcon}") no-repeat 50% 50% / 50px;
`;

export const CreateListLabel = styled.label`
  color: ${colors.black};
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 22px;
  margin-left: 20px;
  display: inline-block;
  width: 100%;
  text-align: left;
  cursor: pointer;
`;

export const NotLoggedInMessage = styled.div`
  padding: 25px 40px;
  flex: 1;
  justify-content: center;
  ${breakpoints.smDown} {
    padding: 20px 15px;
  }
`;

export const NotLoggedInParagraph = styled.p`
  font-size: 18px;
`;

export const NotLoggedInButtonHolder = styled.div`
  width: 100%;
  text-align: center;
`;

export const StyledButtonLink = styled(ButtonLink)`
  height: 60px;
`;
